import React from 'react';
import { Anchor } from '@atlassiansox/bxp-content-framework';
import { RightArrow } from '../icons';
import { BxpLink, getAppearance, getSpacing, getProminence } from './link-button.styles';
export function LinkButton({ appearance, style, children, decorator, isBlock, prominence, onClick, spacing, url, testId }) {
    const buttonText = (React.createElement(React.Fragment, null,
        React.createElement("span", null, children),
        decorator === 'Arrow' && React.createElement(RightArrow, null)));
    const props = {
        bxpAppearance: getAppearance(appearance, style),
        bxpProminence: getProminence(prominence),
        bxpSpacing: getSpacing(spacing),
        bxpIsBlock: isBlock
    };
    return (React.createElement(BxpLink, Object.assign({}, props, { "data-testid": testId }),
        React.createElement(Anchor, { href: url, onClick: onClick }, buttonText)));
}
//# sourceMappingURL=link-button.js.map